import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { t } from '@/i18n';
import type { InvoiceStatus } from '@ip/shared-types';

const STATUS_CLASSES: Record<InvoiceStatus, string> = {
  paid: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400',
  unpaid: 'border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-400',
  exported: 'border-indigo-500/40 bg-indigo-500/10 text-indigo-700 dark:text-indigo-400',
};

export function StatusBadge({ status }: { status: InvoiceStatus }) {
  return (
    <Badge variant="outline" className={cn('font-normal', STATUS_CLASSES[status])}>
      {t(`invoices.status.${status}`)}
    </Badge>
  );
}
